import { render, staticRenderFns } from "./SuccessRequestForgotPassword.vue?vue&type=template&id=6cf5cc32&scoped=true&"
import script from "./SuccessRequestForgotPassword.vue?vue&type=script&lang=js&"
export * from "./SuccessRequestForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./SuccessRequestForgotPassword.vue?vue&type=style&index=0&id=6cf5cc32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf5cc32",
  null
  
)

export default component.exports